/**
 * Formatting utilities for the approvals feature
 */

import { currencyFormatter } from "helpers/formatters";

/**
 * Formats currency amounts for approval displays
 * Uses the standard currencyFormatter with no decimal places for whole dollar amounts
 */
export const formatApprovalAmount = (
  amount: number | null | undefined,
): string => {
  if (amount === null || amount === undefined) {
    return "--";
  }

  // For approvals, we typically show whole dollars unless there are cents
  const hasDecimals = amount % 1 !== 0;

  return currencyFormatter(amount, {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  });
};

/**
 * Formats approval button labels with currency amounts
 */
export const formatApprovalLabel = (
  amount: number | null | undefined,
): string => {
  return formatApprovalAmount(amount);
};

/**
 * Formats currency for grid display in approvals
 */
export const formatGridCurrency = (amount: number): string => {
  return formatApprovalAmount(amount);
};
